class IconManager {
  //
  constructor({ icon, iconHover, iconDisabled, iconLoading, iconLoadingHover }) {
    this._iconDefault = icon;
    this._iconHover = iconHover;
    this._iconLoading = iconLoading;
    this._iconLoadingHover = iconLoadingHover;
    this._iconDisabled = iconDisabled;
  }

  // _getDisabledIcon({ disableOnClick, disabled, clicked }) {
  //   const isDisabled = this.isDisabled({ disabled, disableOnClick, clicked });

  //   if (isDisabled && disableOnClick && this._iconDisabled) {
  //     return this._iconDisabled;
  //   }

  //   return null;
  // }

  // _getLoadingIcon({ loading, loadingOnClick, clicked }) {
  //   if (loading && this._iconLoading) {
  //     return this._iconLoading;
  //   }

  //   if (clicked && loadingOnClick && this._iconLoading) {
  //     return this._iconLoading;
  //   }

  //   return null;
  // }

  // _getHoverIcon({ isHover, loading }) {
  //   if (isHover && !loading && this._iconHover) {
  //     return this._iconHover;
  //   }
  //   if (isHover && loading && this._iconLoading) {
  //     return this._iconLoading;
  //   }
  //   if (!isHover && !loading && this._iconDefault) {
  //     return this._iconDefault;
  //   }
  //   if (!isHover && loading && this._iconLoading) {
  //     return this._iconLoading;
  //   }

  //   return null;
  // }

  // _getDefaultIcon() {
  //   if (this._iconDefault) {
  //     return this._iconDefault;
  //   }

  //   return null;
  // }

  getIcons() {
    const icon = this._iconDefault;
    const iconHover = this._iconHover;
    const iconLoading = this._iconLoading;

    return { icon, iconHover, iconLoading };
  }

  getReactIcon({ isHover, loadingOnClick, disableOnClick, loading, disabled, clicked }) {
    // const loadingIcon = this._getLoadingIcon({ isHover, loading, loadingOnClick, clicked });
    // const disabledIcon = this._getDisabledIcon({ disableOnClick, disabled, clicked });
    // const hoverIcon = this._getHoverIcon({ isHover, loading });
    // const defaultIcon = this._getDefaultIcon();

    // return loadingIcon || disabledIcon || hoverIcon || defaultIcon;

    const isDisabled = this.isDisabled({ disabled, disableOnClick, clicked });
    const isLoading = this.isLoading({ loading, loadingOnClick, clicked });

    if (isDisabled && this._iconDisabled) {
      return this._iconDisabled;
    }

    if (isLoading && isHover && this._iconLoadingHover) {
      return this._iconLoadingHover;
    }

    if (isLoading && !isHover && this._iconLoading) {
      return this._iconLoading;
    }

    if (!isLoading && isHover && this._iconHover) {
      return this._iconHover;
    }

    if (!isLoading && !isHover && this._iconDefault) {
      return this._iconDefault;
    }
  }

  // REFACTOR eliminar esse suporte assim que forem criados ícones react
  // suporte a ícones em svg
  // getSrc({ isActive }) {
  //   const src = {
  //     '--icon': isActive ? `url(${this._iconHover})` : `url(${this._iconDefault})`,
  //     '--iconHover': `url(${this._iconHover})`,
  //     '--iconDisabled': this._iconDisabled
  //       ? `url(${this._iconDisabled})`
  //       : `url(${this._iconDefault})`
  //   };

  //   return src;
  // }

  isDisabled({ disabled, disableOnClick, clicked }) {
    return disabled || (disableOnClick && clicked);
  }

  isLoading({ loading, loadingOnClick, clicked }) {
    return loading || (loadingOnClick && clicked);
  }
}

export default IconManager;
